import styled from 'styled-components'

import { Section as GSSection, Infos as GSInfos } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { colors, media, radii, space } = theme

export const Section = styled(GSSection)`
  position: relative;

  h2 {
    position: relative;
  }

  .ds-button {
    width: 100%;
    border-radius: ${radii['corner-radius-pill']};
    justify-content: center;
  }

  @media (${media.phone}) {
    .ds-button {
      margin-top: ${space['spacing-lg']};
    }
  }

  & > div > div:first-child {
    position: relative;

    h2,
    .ds-button {
      z-index: 2;
    }
  }

  @media (${media.tablet}) {
    &::after {
      content: '';
      position: absolute;
      width: 45vw;
      height: 80%;
      border-right: 3px solid ${colors['cyan-border-default']};
      border-bottom: 3px solid ${colors['cyan-border-default']};
      border-bottom-right-radius: 10rem;
      z-index: 1;
      top: 0;
      left: 0;
    }

    .polygon-pink {
      position: absolute;
      top: 9rem;
      left: 45vw;
      transform: translateX(-50%);
      z-index: 2;
    }

    .ds-button {
      position: absolute;
      top: 100%;
      left: 50%;
      width: 19rem;
      transform: translate(-75%, -90%);
    }
  }

  @media (${media.desktop}) {
    .ds-button {
      transform: translate(-75%, -25%);
    }
  }
`

export const Highlight = styled.span`
  color: ${colors['cashme-magenta']};
  font: inherit;
`

export const Infos = styled(GSInfos)`
  @media (${media.tablet}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: ${space['spacing-lg']} 0;
  }
`

export const BulletList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xxs']};
  list-style: disc;
  padding-inline-start: 1rem;

  p {
    margin: 0;
  }

  /* Só no mobile o CTA fica dentro do Infos, logo depois da lista — e o reset
     global zera a margem da ul, então o botão encostava no último bullet. A
     folga é a mesma que o Infos dá aos parágrafos, para a lista respirar como
     qualquer outro bloco da seção. Do tablet para cima o botão é absoluto e
     não é irmão da lista. */
  @media (${media.phone}) {
    margin-bottom: ${space['spacing-md']};
  }
`
